const {ABILITY_TACTICAL_DISCIPLINE} = require('./../../../../creatureAbilityList')
const {ALIGNMENT_LE} = require('./../../../../aligmentList')
const {CONDITION_FRIGHTENED} = require('./../../../../conditionList')
const {CREATURE_IRON_CONSUL} = require('./../../../../creatureIdList')
const {CR_2} = require('./../../../../crList')
const {DAMAGE_PIERCING} = require('./../../../../damageTypeList')
const {LANG_COMMON} = require('./../../../../languageIdList')
const {PROF_NORMAL} = require('./../../../../proficiencyList')
const {SIZE_MEDIUM} = require('./../../../../sizeList')
const {SOURCE_BGDIA} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')
const {baneFollowerList} = require('./../../../../textCommonParts')
const {
  CREATURE_TYPE_HUMAN,
  CREATURE_TYPE_HUMANOID,
} = require('./../../../../creatureTypeIdList')
const {
  SKILL_INTIMIDATION,
  SKILL_PERCEPTION,
} = require('./../../../../skillList')
const {
  GEAR_SPEAR,
  GEAR_CHAIN_MAIL,
} = require('./../../../../gearIdList')
const {
  ATTACK_MELEE_WEAPON,
  ATTACK_RANGE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')

module.exports = {
  name: 'Железный консул',
  nameEn: 'Iron Consul',
  id: CREATURE_IRON_CONSUL,
  description: baneFollowerList,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_HUMAN,
    CREATURE_TYPE_HUMANOID,
  ],
  alignmentId: ALIGNMENT_LE,
  source: {
    id: SOURCE_BGDIA,
    page: 236,
  },
  armor: {
    ac: 16,
    gearId: GEAR_CHAIN_MAIL,
  },
  hp: {
    diceCount: 6,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 17,
    [PARAM_DEX]: 11,
    [PARAM_CON]: 16,
    [PARAM_INT]: 12,
    [PARAM_WIT]: 15,
    [PARAM_CHA]: 16,
  },
  saveThrowList: [
    PARAM_WIT,
  ],
  skillCollection: {
    [SKILL_PERCEPTION]: PROF_NORMAL,
    [SKILL_INTIMIDATION]: PROF_NORMAL,
  },
  immunityConditionList: [
    CONDITION_FRIGHTENED,
  ],
  languageList: [
    LANG_COMMON,
  ],
  cr: CR_2,
  featureList: [
    ABILITY_TACTICAL_DISCIPLINE,
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает атаку _Копьём_ и может использовать _Командирский голос_.`,
    },
    {
      gearId: GEAR_SPEAR,
    },
    {
      name: 'Командирский голос',
      description: `★СУЩЕСТВО★ выбирает до двух союзников в пределах 90 футов, которые могут слышать ★его★ приказы. Каждый из них может немедленно совершить одну рукопашную атаку реакцией.`,
    },
  ],
}
